import { Styles } from 'assets/types';
import globalLabelsCellStyles from 'assets/stylesheets/defaultStyles/labelsCell.style';

const labelsCellStyles: Styles = theme => ({
  ...globalLabelsCellStyles(theme),
});

export default labelsCellStyles;
